import { render } from "./loading.vue?vue&type=template&id=2cd156ae"
const script = {}

import "./loading.vue?vue&type=style&index=0&id=2cd156ae&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__